"use client";
import * as React from "react";
import { useEffect, useMemo, useState } from "react";
import { useAppContext } from "@components/Provider";
import DealsBanner from "./DealsBanner";
import styles from "./DealsPageNew.module.css";
import "./DealsPage.css";
import FilterComponentNew from "./FilterComponentNew";
import DealsListNew from "./DealsListNew";
import FilterSliderNew from "./FilterSliderNew";
import { transformBookDealsData } from "./dealsHelper";
import NewsletterV2 from "@components/NewsletterV2/NewsletterV2";

const DealsPageNew = ({ postData, filters, retailers }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedFilters, setSelectedFilters] = useState({});
  const { data, subscriberCookie, siteId } = useAppContext();
  const { SiteSettings } = data;

  const { post, totalPages, pageSize, currentPage } = postData || {};

  const pageBuilderOptions = {
    //deviceSize: props.Device_Size,
    Newsletter_Settings: {
      ...SiteSettings.newsletter_settings,
    },
    postType: post.post_type,
    pageSize,
    lastPageNumber: totalPages,
    currentPageNumber: currentPage,
    skip: currentPage > 0 && (currentPage - 1) * pageSize,
  };
  const banner = useMemo(() => {
    return post.title || post.sub_title ? (
      <DealsBanner title={post.title} subtitle={post.sub_title} />
    ) : null;
  }, [post.title, post.sub_title]);

  // ✅ Extract initial deals from `post`
  const bookDeals = post?.components;
  const totalComponents = post?.componentsCount;

  // ✅ State to manage deals
  const [deals, setDeals] = useState([]); // Stores fetched deals (initial or filtered)
  const [activeDeals, setActiveDeals] = useState([]); // ✅ Controls which deals are sent to `DealsListNew`
  const [totalDeals, setTotalDeals] = useState(totalComponents || null);
  const [defaultOpenAccordion, setDefaultOpenAccordion] = useState("");

  // ✅ Format initial deals
  useEffect(() => {
    async function formatInitialDeals() {
      if (bookDeals && bookDeals.length > 0) {
        const formattedDeals = await transformBookDealsData(bookDeals);
        setDeals(formattedDeals); // Store initial deals
        setActiveDeals(formattedDeals); // ✅ Set active deals
      }
    }
    formatInitialDeals();
  }, [bookDeals]);

  const renderNewsletter = () => {
    const clonePost = { ...post };
    let newsletterProps =
      clonePost?.components?.length > 0 &&
      clonePost.components.filter((item) => {
        if (
          item &&
          item.type === "newsletter" &&
          item.props.nonClosableModalProps
        ) {
          //filter out all newsletters with type display as modal or nonclosable modal
          if (!item.props.nonClosableModalProps.nonClosableModal) {
            return item;
          }
        } else {
          return item;
        }
      });
    return (
      newsletterProps.length > 0 &&
      newsletterProps.map((obj, index) => {
        if (
          obj.type === "newsletter-v2" &&
          obj.props.subComponentType === "inline"
        ) {
          return (
            <React.Fragment key={index}>
              <div className="newsletter_wrapper">
                <NewsletterV2
                  classNames="newsLettetPb dealspage__newsletter"
                  buttonBoxButtonClass="newsletter_top_button"
                  {...obj.props}
                  {...pageBuilderOptions}
                  OptIn={false}
                  buttonText="Subscribe"
                  textBoxPlaceholder="Enter Your E-mail"
                  siteId={siteId}
                />
              </div>
            </React.Fragment>
          );
        }
      })
    );
  };

  return (
    <div className="dealspage">
      {!subscriberCookie && renderNewsletter()}
      <div className={styles.pageWrapper}>
        {/* Full-Width Title Section */}
        {banner}
      </div>
      <FilterComponentNew
        selectedFilters={selectedFilters}
        loading={loading}
        setShowMenu={setShowMenu}
        setSelectedFilters={setSelectedFilters}
        setDefaultOpenAccordion={setDefaultOpenAccordion}
        slug={post.slug[0]}
        postType={post.post_type}
      />
      <DealsListNew
        initialDeals={bookDeals} // Keep for reference
        totalComponents={totalComponents}
        postType={post.post_type}
        deals={activeDeals} // ✅ Use `activeDeals` to control displayed deals
        totalDeals={totalDeals} // Pass total deals state
        selectedFilters={selectedFilters}
        totalPages={totalPages}
        bannerInfo={post?.dealsbannermedia ? post.dealsbannermedia : null}
        loading={loading}
        setLoading={setLoading}
        slug={post.slug?.[0]} // Pass the slug from post data
      />
      <FilterSliderNew
        filters={filters || []}
        retailers={retailers || []}
        showMenu={showMenu}
        selectedFilters={selectedFilters}
        defaultOpenAccordion={defaultOpenAccordion}
        setDefaultOpenAccordion={setDefaultOpenAccordion}
        setSelectedFilters={setSelectedFilters}
        setShowMenu={setShowMenu}
        postType={post.post_type}
      />
    </div>
  );
};

export default DealsPageNew;